import React from "react";
import {
  Typography,
  Dialog,
  DialogContent,
  Button,
  DialogActions,
  styled,
  DialogTitle,
} from "@mui/material";

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: "16px 0px",
  gap: "8px",
  flexDirection: "column-reverse",
  alignItems: "center",
  [theme.breakpoints.up("sm")]: {
    padding: "16px 8px",
    gap: "16px",
    flexDirection: "row",
    alignItems: "end",
  },
}));

const StyledDialog = styled(Dialog)({
  ".MuiDialog-paper": {
    maxWidth: "800px",
    borderRadius: "8px",
    width: "100%",
  },
});

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "100px",
  maxWidth: "290px",
  textTransform: "none",
  "&:hover, &:focus": {
    cursor: "pointer",
  },
  [theme.breakpoints.up("sm")]: {
    padding: "9px 50px",
  },
  gap: "6px",
}));

export interface ActionModalButtonProps {
  label: string;
  onClick: () => void;
}

export interface ActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: React.ReactNode;
  primaryButton: ActionModalButtonProps;
  secondaryButton: ActionModalButtonProps;
}

export const ActionModal: React.FC<ActionModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <StyledDialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {description ? (
          <Typography variant="subtitle1" component="div">
            {description}
          </Typography>
        ) : null}
      </DialogContent>
      <StyledDialogActions>
        <StyledButton
          onClick={secondaryButton.onClick}
          variant="text"
          color="primary"
        >
          {secondaryButton.label}
        </StyledButton>
        <StyledButton variant="contained" onClick={primaryButton.onClick}>
          {primaryButton.label}
        </StyledButton>
      </StyledDialogActions>
    </StyledDialog>
  );
};
